import React, { useState } from "react"
import { Link, graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import WorkPostTeaser from "../components/workpostteaser"
import InView from "react-intersection-observer"
import { motion, AnimatePresence } from "framer-motion"

const openWorkPostAnim = {
  open: {
    width: '100vw',
  },
  closed: {
    opacity: 0,
  },
}

const WorkSectorArchive = ({
  data
}) => {
  const posts = data.wpWorkSector.workPosts.nodes
  if (!posts.length) {
    return (
      <Layout>
        <SEO 
          title="All posts" 
          canonical={data.wpWorkSector.uri} 
          metaRobotsNofollow="nofollow"
          metaRobotsNoindex="noindex"
        />
        <p>No posts</p>
      </Layout>
    )
  }

  return (
    <Layout>
      <SEO 
        title={`Work posts - ${data.wpWorkSector.name}`} 
        canonical={data.wpWorkSector.uri} 
        metaRobotsNofollow={posts[0].workSectors.nodes[0].seo.metaRobotsNofollow}
        metaRobotsNoindex={posts[0].workSectors.nodes[0].seo.metaRobotsNoindex}
      />

      <section className="pt-32 lrg:pt-44">
        <div className="container">
          <div className="desk:flex mb-20">
            <InView threshold={0.25} triggerOnce >
              {({ ref, inView }) => (
                <motion.div
                  ref={ref}
                  initial={{opacity: 0, y: 40}}
                  animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 40 }}
                  transition={{duration: 0.8}}
                  className="desk:w-3/5 desk:px-6">
                  <h1 className="text-mobmd lrg:text-xl">{data.wpWorkSector.name}</h1>
                </motion.div>
              )}
            </InView>
          </div>
        </div>
      </section>

      <section className="pt-10 pb-32">
        <div className="px-0 med:px-7 container">
          <div className="block med:flex flex-wrap items-center">
            {
              posts.map((post, i) => {
                let colWidth = "4/6"
                if( i===1 || i===4 || i===6 || i==9 ) {
                  colWidth = "2/6"
                }
                if(i > 9) {
                  colWidth = "2/6"

                  if(i % 3 === 0) {
                    colWidth = "4/6"

                  }
                }
                return (
                  <>
                  <div className={`pb-10 med:pb-16 med:pt-16 lrg:px-6 med:w-1/2 note:w-${colWidth}${(i===2 || i===5) ? ' note:ml-auto' : ''}${(i===6) ? ' transform note:-translate-y-3/4' : ''}${(i===6 || i===7) ? ' z-20' : ''}${(i===5 || i===6 || i===7) ? ' note:text-white' : ''}`}>

                    {
                      (i===5) ?
                        <div className="work-black-section hidden note:block bg-black w-screen absolute -mt-16 z-10"></div>
                      : ''
                    }
                    <WorkPostTeaser
                      key={post.uri}
                      uri={post.uri}
                      title={post.title}
                      featuredImage={post.featuredImage}
                      workSectors={post.workSectors.nodes}
                    />
                  </div>
                  {
                    (i===2 || i===5) ?
                      <div className="note:flex-100"></div>
                    : ''
                  }


                  </>
                )
              })
            }
          </div>
        </div>
      </section>

    </Layout>
  )
}

export default WorkSectorArchive

export const pageQuery = graphql`
  query WordPressWorkSectorArchive($id: String!) {
    wpWorkSector(
      id: { eq: $id }
    ) {
      name
      uri
      workPosts {
        nodes {
          id
          title
          uri
          workSectors {
            nodes {
              name
              uri
              seo {
                metaRobotsNofollow
                metaRobotsNoindex
                canonical
              }
            }
          }
          workDistributions {
            nodes {
              name
              uri
            }
          }
          featuredImage {
            node {
              altText
              localFile {
                childImageSharp {
                  fluid(maxWidth: 1024) {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
